import { render, staticRenderFns } from "./TextInformativeModalCompany.vue?vue&type=template&id=eb5e6fe4&scoped=true&"
import script from "./TextInformativeModalCompany.vue?vue&type=script&lang=js&"
export * from "./TextInformativeModalCompany.vue?vue&type=script&lang=js&"
import style0 from "./TextInformativeModalCompany.vue?vue&type=style&index=0&id=eb5e6fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e6fe4",
  null
  
)

export default component.exports